export const formContentStyle = {
	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		maxWidth: '970px',
		margin: '0 auto',
		gap: '40px',
		marginBottom: '40px',
	},
};
